import { axiosInstance } from 'src/services/index';
import { getStore } from 'src/utils/store-bridge';
import { useToast } from 'src/utils/toast';

let axios = axiosInstance;

export function login(baseUrl, data, hostUrl, config, spinner, log, alert) {
  if (spinner) {
    getStore()?.dispatch('turnOnSpinner');
  }
  return axios
    .post(hostUrl + baseUrl, data, config)
    .then((response) => response.data)
    .then((response) => {
      if (spinner) {
        getStore()?.dispatch('turnOffSpinner');
      }
      if (log) {
        // console.log("response");
        // console.log(response);
      }
      return response;
    })
    .catch((error) => {
      if (alert) {
        useToast().error(error.response.data.non_field_errors[0]);
      }
      if (spinner) {
        getStore()?.dispatch('turnOffSpinner');
      }
      return 'error';
    });
}

export function register(
  baseUrl,
  data,
  hostUrl,
  config,
  spinner,
  log,
  alert,
  successMessage
) {
  if (spinner) {
    getStore()?.dispatch('turnOnSpinner');
  }

  return axios
    .post(hostUrl + baseUrl, data, config)
    .then((response) => response.data)
    .then((response) => {
      if (alert) {
        useToast().success(successMessage);
      }
      // "Form Submitted!"

      if (spinner) {
        getStore()?.dispatch('turnOffSpinner');
      }

      if (log) {
        // console.log("response");
        // console.log(response);
      }
      return response;
    })
    .catch((error) => {
      if (alert) {
        if (error.response) {
          useToast().error(error.response.data.email[0]);
        } else if (error.request) {
          useToast().error(error.request);
        } else {
          useToast().error(error.message);
        }
      }
      if (spinner) {
        getStore()?.dispatch('turnOffSpinner');
      }
      return error;
    });
}
